import type { ChecklistItem, MaintenanceEvent } from '~/api/types'
import type { ImpactRow, ResultItem } from './types'
import { AffectedItemList } from './impact-aside-items'
import { SelectedImpactCard } from './selected-impact-card'
import { ChangeSummaryCard } from './change-summary-card'
import { ChecklistOverviewCard } from './checklist-overview-card'
import { RecheckSummaryCard } from './recheck-summary-card'

export function ImpactDetailAside({
    activeEvent,
    checklist,
    resultItems,
    selectedImpact,
    recheckCount,
    keepCount,
    unaffectedCount,
    onSelectImpact,
}: {
    activeEvent: MaintenanceEvent
    checklist: ChecklistItem[]
    resultItems: ResultItem[]
    selectedImpact: ImpactRow | null
    recheckCount: number
    keepCount: number
    unaffectedCount: number
    onSelectImpact(itemId: string): void
}) {
    return (
        <aside
            className='min-h-0 overflow-y-auto pr-1 max-lg:hidden'
            aria-label='이 대화 요약'>
            <div className='flex min-h-0 flex-col gap-3'>
                <ChangeSummaryCard activeEvent={activeEvent} />
                <RecheckSummaryCard
                    recheckCount={recheckCount}
                    keepCount={keepCount}
                    unaffectedCount={unaffectedCount}
                />
                <AffectedItemList
                    resultItems={resultItems}
                    onSelectImpact={onSelectImpact}
                />
                <SelectedImpactCard selectedImpact={selectedImpact} />
                <ChecklistOverviewCard
                    checklist={checklist}
                    resultItems={resultItems}
                    unaffectedCount={unaffectedCount}
                />
            </div>
        </aside>
    )
}
